// cr_thuoc, cr_vtyt, cr_hc
const API_URL = "https://api135.goodapp.vn/api";
const PUBLIC_URL = "https://api135.goodapp.vn";
// const ID_APP = "66432d1af06bef4e9985aa6a"; // thien thuy
// const ID_APP = "60939744ac969b4078488026"; // dev
// const ID_APP = "66f002780432a228d2b5fde5"; // cr
const ID_APP = "6704a10f7521a7107f5331f2"; // cr test
const PUBLIC_TOKEN = "flex.public.token";
const FIRST_PATH = "/list/cr_thuoc";
const ACCEPT_REGEX = "[\\p{L}0-9\\s()]*";
const VIEW_RIGHT = "view";
const VIEWOFOTHER_RIGHT = "viewOfOther";
const ADD_RIGHT = "add";
const UPDATE_RIGHT = "update";
const DELETE_RIGHT = "delete";
const ROLES: { label: string; value: string }[] = [
  { label: "Mọi người", value: "0" },
  { label: "Người tạo, phục trách, quản trị viên", value: "1" },
  // { label: "Người dùng chỉ định", value: "2" },
  { label: "Nhóm người dùng chỉ định", value: "5" },
];

export {
  API_URL,
  PUBLIC_URL,
  ID_APP,
  PUBLIC_TOKEN,
  FIRST_PATH,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
  ADD_RIGHT,
  UPDATE_RIGHT,
  DELETE_RIGHT,
  ROLES,
  ACCEPT_REGEX,
};
